export default "__VITE_ASSET__CV34hdzs__"